import {pipe} from 'ramda'
import {TaxConfig} from 'types/Localization'

import {TransformRoomsResponse} from '../../../sapi/services/searchApi'
import {sortRoomsByNightlyDisplayTotalAsc} from '../utils/sortRooms'
import {
  clearIsClickedRoomOffers,
  clearIsClickedSplitBooking
} from './clearIsclicked'
import {decoratePrices, decorateSplitBookingPrices} from './decoratePrices'

export type TransformOptions = TaxConfig & {
  clearIsClickedFlag?: boolean
}

/**
 * Generate a transform function with options to be passed into the `transformResponse` param of `getRoomsQuery`
 *
 * !!NOTE: before adding more transformations, consider whether they should actually be applied at the source API (SAPI) or display level instead
 */
export const makeTransformSapiRoomsResponse =
  (transformOptions: TransformOptions): TransformRoomsResponse =>
  (response, params) => {
    const transformedRooms = pipe(
      rooms => decoratePrices(rooms, params, transformOptions),
      rooms =>
        transformOptions?.clearIsClickedFlag
          ? clearIsClickedRoomOffers(rooms)
          : rooms,
      sortRoomsByNightlyDisplayTotalAsc
    )(response.rooms)

    const {splitBooking} = response
    const transformedSplitBooking = splitBooking
      ? pipe(
          splitBooking =>
            decorateSplitBookingPrices(splitBooking, params, transformOptions),
          splitBooking =>
            transformOptions?.clearIsClickedFlag
              ? clearIsClickedSplitBooking(splitBooking)
              : splitBooking
        )(splitBooking)
      : undefined

    return {
      ...response,
      rooms: transformedRooms,
      splitBooking: transformedSplitBooking
    }
  }
